import { ProvisionItem } from "./provisionitem";
import { KeyValuePair } from "./keyvaluepair";
import { ProvisionChange } from "./provisionchange";
import { Suggestion } from "./suggestion";

export class StructureControlResponse {

    ErrorMessages: Array<KeyValuePair>;
    Suggestions: Array<Suggestion>;
    Success: boolean;
    StoppingStructureErrors: boolean;
    FPCConflict: boolean;
    ConflictFPCs: Array<ProvisionItem>;
    IgnoreCO: boolean;
    OnlyIndicateStoppingStructureErrors: boolean;
    AdditionalChanges: Array<ProvisionChange>;
    VSpec: Array<ProvisionItem>

    constructor() {

    }
}